module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#bundle",
      toString: function () {
        return this.url;
      }
    }